"use strict";

var _regeneratorRuntime = require("/Users/georgiavramov/limechain/new-abridged/abridged/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/Users/georgiavramov/limechain/new-abridged/abridged/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/georgiavramov/limechain/new-abridged/abridged/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var constants_1 = require("../constants");

var KChannelsClient = /*#__PURE__*/function () {
  function KChannelsClient(options, connectionOptions) {
    _classCallCheck(this, KChannelsClient);

    this.options = options;
    this.connectionOptions = connectionOptions;
  }

  _createClass(KChannelsClient, [{
    key: "getAuthenticationChallengeTypedMessage",
    value: function getAuthenticationChallengeTypedMessage(address) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var requestChallengeResponse, body;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.connectionOptions.fetch(KChannelsClient.buildUri(this.options, "/authentication_api/?signing_identity=".concat(address, "&client_unpredictable_number=").concat(KChannelsClient.generateUnpredictableNumber())), {
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  method: 'GET'
                });

              case 2:
                requestChallengeResponse = _context.sent;
                _context.next = 5;
                return requestChallengeResponse.json();

              case 5:
                body = _context.sent;

                if (requestChallengeResponse.ok) {
                  _context.next = 8;
                  break;
                }

                throw new Error(body);

              case 8:
                return _context.abrupt("return", {
                  data: body,
                  typedMessage: JSON.stringify(KChannelsClient.buildAuthTypedMessage(this.options, body))
                });

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "authenticate",
    value: function authenticate(body) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var authenticationResponse, result;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.connectionOptions.fetch(KChannelsClient.buildUri(this.options, '/authentication_api/'), {
                  method: 'POST',
                  body: JSON.stringify(body),
                  headers: {
                    'Content-Type': 'application/json'
                  }
                });

              case 2:
                authenticationResponse = _context2.sent;
                _context2.next = 5;
                return authenticationResponse.json();

              case 5:
                result = _context2.sent;

                if (authenticationResponse.ok) {
                  _context2.next = 8;
                  break;
                }

                throw new Error(result);

              case 8:
                return _context2.abrupt("return", result);

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "getClientInformation",
    value: function getClientInformation(token) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var getClientInformationResponse, result;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.connectionOptions.fetch(KChannelsClient.buildUri(this.options, '/ui/client_api/'), {
                  method: 'GET',
                  headers: {
                    Authorization: "Bearer ".concat(token)
                  }
                });

              case 2:
                getClientInformationResponse = _context3.sent;
                _context3.next = 5;
                return getClientInformationResponse.json();

              case 5:
                result = _context3.sent;

                if (getClientInformationResponse.ok) {
                  _context3.next = 8;
                  break;
                }

                throw new Error(result);

              case 8:
                return _context3.abrupt("return", result);

              case 9:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    }
  }, {
    key: "createChannelDefinition",
    value: function createChannelDefinition(token) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", this.channelRequest(token, constants_1.KChannelsJSONRpcMethodNames.CreateChannelDefinition));

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
    }
  }, {
    key: "updateChannelDefinition",
    value: function updateChannelDefinition(token, body) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt("return", this.channelRequest(token, constants_1.KChannelsJSONRpcMethodNames.UpdateAndCompleteChannelDefinition, body));

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));
    }
  }, {
    key: "getChannelDefinitionTypedMessage",
    value: function getChannelDefinitionTypedMessage(data) {
      return JSON.stringify(KChannelsClient.buildChannelDefinitionTypedMessage(this.options, data));
    }
  }, {
    key: "getTransactionTypedMessage",
    value: function getTransactionTypedMessage(data, primaryType) {
      return JSON.stringify(KChannelsClient.buildTransactionTypedMessage(this.options, data, primaryType));
    }
  }, {
    key: "createNewTransaction",
    value: function createNewTransaction(zoneLocationUrl, args, token) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                return _context6.abrupt("return", this.transactionRequest(zoneLocationUrl, token, constants_1.KChannelsJSONRpcMethodNames.CreateNewTransaction, args));

              case 1:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));
    }
  }, {
    key: "processTransaction",
    value: function processTransaction(zoneLocationUrl, args, token) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                return _context7.abrupt("return", this.transactionRequest(zoneLocationUrl, token, constants_1.KChannelsJSONRpcMethodNames.ProcessTransaction, args));

              case 1:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));
    }
  }, {
    key: "completeTransaction",
    value: function completeTransaction(zoneLocationUrl, args, token) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                return _context8.abrupt("return", this.transactionRequest(zoneLocationUrl, token, constants_1.KChannelsJSONRpcMethodNames.CompleteTransaction, args));

              case 1:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));
    }
  }, {
    key: "createChannelWebSocketConnection",
    value: function createChannelWebSocketConnection(zoneLocation, channelDefinition, jwt) {
      return this.createWebsocketConnection(zoneLocation, channelDefinition, jwt, constants_1.KChannelsWebSocketTypes.Channel);
    }
  }, {
    key: "createTransactionWebSocketConnection",
    value: function createTransactionWebSocketConnection(zoneLocation, channelDefinition, jwt) {
      return this.createWebsocketConnection(zoneLocation, channelDefinition, jwt, constants_1.KChannelsWebSocketTypes.Transaction);
    }
  }, {
    key: "createWebsocketConnection",
    value: function createWebsocketConnection(zoneLocation, channelDefinition, jwt, connectionType) {
      return new this.connectionOptions.WebSocket("".concat(KChannelsClient.buildWebSocketUriFromHttps(zoneLocation), "ws/").concat(connectionType, "/").concat(channelDefinition.channel_uuid, "/").concat(channelDefinition.definition_version, "/?access_token=").concat(jwt));
    }
  }, {
    key: "transactionRequest",
    value: function transactionRequest(url, token, methodName, body) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
        var transactionResponse, result;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return this.connectionOptions.fetch("".concat(url, "transaction/"), {
                  body: KChannelsClient.buildJSONRPCRequestBody(methodName, body),
                  method: 'POST',
                  headers: {
                    Authorization: "Bearer ".concat(token),
                    'Content-Type': 'application/json'
                  }
                });

              case 2:
                transactionResponse = _context9.sent;
                _context9.next = 5;
                return transactionResponse.json();

              case 5:
                result = _context9.sent;

                if (transactionResponse.ok) {
                  _context9.next = 8;
                  break;
                }

                throw new Error(result);

              case 8:
                if (!result.error) {
                  _context9.next = 10;
                  break;
                }

                throw new Error(result.error.message);

              case 10:
                return _context9.abrupt("return", result);

              case 11:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));
    }
  }, {
    key: "channelRequest",
    value: function channelRequest(token, methodName, body) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
        var createChannelDefinitionResponse, result;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return this.connectionOptions.fetch(KChannelsClient.buildUri(this.options, '/client/channel/'), {
                  body: KChannelsClient.buildJSONRPCRequestBody(methodName, body),
                  method: 'POST',
                  headers: {
                    Authorization: "Bearer ".concat(token),
                    'Content-Type': 'application/json'
                  }
                });

              case 2:
                createChannelDefinitionResponse = _context10.sent;
                _context10.next = 5;
                return createChannelDefinitionResponse.json();

              case 5:
                result = _context10.sent;

                if (createChannelDefinitionResponse.ok) {
                  _context10.next = 8;
                  break;
                }

                throw new Error(result);

              case 8:
                if (!result.error) {
                  _context10.next = 10;
                  break;
                }

                throw new Error(result.error.message);

              case 10:
                return _context10.abrupt("return", result);

              case 11:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));
    }
  }, {
    key: "depositAddress",
    get: function get() {
      return this.options.verifyingContract;
    }
  }], [{
    key: "buildUri",
    value: function buildUri(options, url) {
      return "".concat(options.useSsl ? 'https' : 'http', "://").concat(options.host).concat(url);
    }
  }, {
    key: "buildWebSocketUriFromHttps",
    value: function buildWebSocketUriFromHttps(url) {
      return url.replace('https://', 'wss://');
    }
  }, {
    key: "generateUnpredictableNumber",
    value: function generateUnpredictableNumber() {
      return Math.abs(Math.floor(Math.random() * 10E10));
    }
  }, {
    key: "buildAuthTypedMessage",
    value: function buildAuthTypedMessage(options, data) {
      return {
        types: {
          EIP712Domain: constants_1.EIP712Domain,
          AuthenticationChallenge: constants_1.KChannelsAuthenticationChallenge
        },
        domain: {
          name: options.name,
          version: options.version,
          chainId: options.chainId,
          verifyingContract: options.verifyingContract,
          salt: options.salt
        },
        primaryType: constants_1.EIP712SignaturePrimaryTypes.AuthenticationChallenge,
        message: data
      };
    }
  }, {
    key: "buildChannelDefinitionTypedMessage",
    value: function buildChannelDefinitionTypedMessage(options, data) {
      var messageToSign = {
        channel_uuid: data.channel_uuid,
        channel_rating_id: data.channel_rating_id,
        definition_version: data.definition_version,
        zone_address: data.zone_address,
        owner_address: data.owner_address,
        deposit_address: data.deposit_address,
        validator_address: data.validator_address,
        sender_address_list: data.sender_address_list,
        initial_state_hash: data.initial_state_hash
      };
      return {
        types: {
          EIP712Domain: constants_1.EIP712Domain,
          ChannelDefinition: constants_1.KChannelsChannelDefinition
        },
        domain: {
          name: options.name,
          version: options.version,
          chainId: options.chainId,
          verifyingContract: options.verifyingContract,
          salt: options.salt
        },
        primaryType: constants_1.EIP712SignaturePrimaryTypes.ChannelDefinition,
        message: messageToSign
      };
    }
  }, {
    key: "buildTransactionTypedMessage",
    value: function buildTransactionTypedMessage(options, data, primaryType) {
      return {
        primaryType: primaryType,
        types: {
          EIP712Domain: constants_1.EIP712Domain,
          ChannelAsset: constants_1.KChannelsChannelAssetDefinition,
          ChannelState: constants_1.KChannelsChannelStateDefinition,
          ChannelDefinition: constants_1.KChannelsChannelDefinition,
          TransactionValue: constants_1.KChannelsTransactionValueDefinition,
          TransactionParty: constants_1.KChannelsTransactionPartyDefinition,
          Transaction: constants_1.KChannelsTransactionDefinition,
          TransactionSummary: constants_1.KChannelsTransactionSummaryDefinition,
          TransactionMetadata: constants_1.KChannelsTransactionMetadataDefinition
        },
        domain: {
          name: options.name,
          version: options.version,
          chainId: options.chainId,
          verifyingContract: options.verifyingContract,
          salt: options.salt
        },
        message: data
      };
    }
  }, {
    key: "buildJSONRPCRequestBody",
    value: function buildJSONRPCRequestBody(methodName, params) {
      return JSON.stringify({
        jsonrpc: '2.0',
        id: 1,
        method: methodName,
        params: params ? Array.isArray(params) ? params : [params] : []
      });
    }
  }]);

  return KChannelsClient;
}();

exports.KChannelsClient = KChannelsClient;